import { render, staticRenderFns } from "./CreateMaskScopeForm.vue?vue&type=template&id=8c8e8f40"
import script from "./CreateMaskScopeForm.vue?vue&type=script&lang=js"
export * from "./CreateMaskScopeForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports